// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:07:58+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            098465ba842e1b1d4458d294031fde4b
//    Signature:      eyJpdiI6IkVNZEtLYW4yQzdYa1VnYUNlOEFJWUE9PSIsInZhbHVlIjoiYys4YTBFWVQ4clpVM0U0dVBXZ3Z5K3lDNTZBcmdDMUJaS3BnQTk5cExxSlFQMExcL1kzdXZTSWdQZjI2c0xvK3ZuVjJKZXVPREt5MVRJRlVSb0JuNkdDeVNGNzFmZWdhc1wvQjZNTTljZmpTcVNHb1BKb2tWbGM0UEc4ZXd6Sm1PZXY1NXprbE5wMEVVcmV1XC9LMjRcLzNObTdoWFQ2RkUwZldRNTBNRVQyWlFHRUsxRk9EV2VGeVFEOXVZUk9NZVIybll5VHRIMzNncjJEYlR6cHZVc1VuS1dJTTdHdXkwMUU5ZlUrOWJpKytsY0xUMzVwUExHVStcL3ppYkFyQ25LMWpUN0t1NG90WXdBT1Y5Q09DYkh5UWJOWFZLUm8zRUpXYmlLWWxndTByaUJiclErNGxQT0NDNnZ4ZTVQSEo2eU9zSEtkYjRaTTVmRzhBeVFET1hDSFZRYnVIcDVQaEpyOVU0eHFVQmhDZXhUTmNLdytMMVdDRnF1WWJ2dE1wODBnc0NTMk5HbFBkM1wvRllwaFJlbWpMUFhoQT09IiwibWFjIjoiY2E5ODY5N2M0MDFkMTAyYWUxOTc1YTZmMDBhYzZkZDY4NzQ2MDUzOTg4OGZmNjZjODA0YjlhODhjYmJkY2U5OSJ9
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
